import ButtonComponent from '../Inputs/ButtonComponent'
import { useLocation, useNavigate } from 'react-router-dom'
import { useNavigation } from '../../Context/NavigationContext'


const Historic1FilterComponent = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const {currentSidebarTab, handleUpdateCurrentSidebarTab} = useNavigation()

  const goBack = () => {
    handleUpdateCurrentSidebarTab('Shared', location.pathname)
  };

  return (
    <div className="h-14 px-4 w-full flex flex-col justify-center bg-dark-card border border-dark-border rounded-xl mb-4">
      <ButtonComponent label='Back' handler={goBack}/>
    </div>
  )
}

export default Historic1FilterComponent
